<template>
  <div class="about" v-if="data">
    <!-- <TopMenu/> -->
    <!-- IndexPage.vue -->
   
    <!-- <div class="container full-width-outer hero" v-bind:style="{backgroundImage: backgroundUrl}">
      <div class="header-spacer"></div> -->
      <!-- <div class="overlay"></div> -->
      <!-- <div class="row row-center">
        <transition name="slide" appear v-if="show"> -->
        <!-- <div class="column column-50 index-cta"> -->
        <!-- <div class="column column-60"> -->
          <!-- <div class="vert-center"> -->
  
              <!-- <div class="cta-inner">
                <div class="heading-wrap rounded-border"><h1 class="has-color-initial" style="text-align: center;">{{ data.title }}</h1></div>
              
              <div v-for="c in data.content" v-bind:key="c.value" class="column has-color-initial">
                <div v-html="c.value" class="size-2 size-500"></div>
              </div>
              </div>
        </div>
        </transition> -->
        <!-- <div class="column"> -->
        <!-- <div class="column no-padding index-image" v-bind:style="{backgroundImage: 'url('+data.hero_image_top.url+')'}"> -->
             <!-- <img :src='data.hero_image_top.url' v-if='data.hero_image_top'> -->
        <!-- </div>
      </div>
    </div> -->
    
    <div class="header-spacer"></div>
    
    <!-- <div v-if=data.search>
      <div v-if="data.search.length > 0"> -->
        <SearchBlock :pageType='data.meta.type' @filterChange='filter_array=$event; filterAll()' @dateFilterChange='currentDateFilter=$event; filterAll()'/>
      <!-- </div>
    </div> -->
     

    <!-- Map Link -->
    <!-- <MapBar/> -->
    <!-- End Map Link -->


      <Pagination :pageType='subPageType' :limit='21' :fields='["*","-node","-hero_image","-hero_image_top","-related_items","-parent_related_items","-custom_styles","-map_thumbnail"]' :filters='pagiFilter' :order='subPageOrder' :dates='currentDateFilter'/>
  </div>
</template>

<script>
// import TopMenu from '@/components/TopMenu.vue'
import SearchBlock from '@/components/SearchBlock.vue'
import Pagination from '@/components/Pagination.vue'
import MapBar from '@/components/MapBar.vue'
import LazyLoad from '@/utils/LazyLoad'
import axios from 'axios'
export default{
  name: 'IndexPage',
  directives: {
    lazyload: LazyLoad
  },
  data(){
    return{
      data: null,
      subpages: [],
      filter_array: [],
      grouped_pages: [],
      show: true,
      currentDateFilter: null,
      dateFiltered: null,
      loading_data: false,
      // pagination: {
      //   offset: 0,
      //   limit: 20,
      //   total: 0,
      //   current_page: 1,
      // },
      source: axios.CancelToken.source(),
      // queryString: {
      //   filter: '',
      //   fields: '&fields=*,-node,-hero_image,-hero_image_top,-related_items,-parent_related_items,-custom_styles',
      //   limit: '&limit=20',
      //   offset: '&offset=0',
      //   child_of: '&child_of='+this.$route.meta.id,
      // },
      pagiFilter: []
    }
  },
  components: {
    MapBar,
    SearchBlock,
    Pagination,
  },
  beforeRouteLeave (to, from, next){
    console.log('b4 route leave')
    this.show = false
    this.currentDateFilter = null;
    // next();
    setTimeout(function (){
      next()
    }, 250)
    if (this.data.custom_styles) {
      let tempSty = document.getElementById('temp-styles');
      if (tempSty) {
        tempSty.remove();
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    setTimeout(function (){
    next(vm => {
      // access to component instance via `vm`
      vm.show = true
    })
    }, 300)
  },
  computed: {
    subPageType: function() {
      let type = this.data.meta.type;
      let subType = 'pages.BasicPage';
      if (type == 'pages.EventIndexPage') {
        subType = 'pages.EventPage';
      }
      return subType;
    },
    subPageOrder: function() {
      let type = this.data.meta.type;
      let order = 'title';
      if (type == 'pages.EventIndexPage') {
        order = 'start_date';
      }
      return order;
    },
    backgroundUrl: function() {
      let url = ''
      if (this.data.hero_image_top) {
        url = 'url('+this.data.hero_image_top.url+')';
      }
      return url;
    },
    page_count: function() {
      let count = Math.ceil(this.pagination.total/this.pagination.limit);
      return count;
    },
    currentDisplayCeil: function() {
      let ceil = this.pagination.offset + this.pagination.limit;
      if (ceil > this.pagination.total) {
        return this.pagination.total;
      }
      return ceil;
    },
    queryOffset: function() {
      let temp = this.pagination.limit*(this.pagination.current_page-1);
      return '&offset='+temp;
    }
  },
  // beforeRouteLeave (to, from, next) {
  //   this.currentDateFilter = null;
  //   next();
  // },
  created (){
    this.fetchData().then(data =>{
      console.log("THis is atea");
      this.data = data
      console.log('THis is more');
      if (this.data.custom_styles) {
        let styles = document.createElement('style');
        styles.type = 'text/css';
        styles.id = 'temp-styles';
        for (let d in this.data.custom_styles) {
          if (!this.data.custom_styles[d].value.hide) {
            styles.appendChild(document.createTextNode(this.data.custom_styles[d].value.style));
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    })
    // console.log("~~~ This is the route information: ", this.$route.meta)
    // if (this.$route.meta.hasOwnProperty('fromHistory')) {
    //   if (this.$route.meta['fromHistory'] == true) {
    //     console.log("This is from the History")
    //     if (localStorage.getItem('pagination')) {
    //       // let tempUrl = localStorage.indexCall;
    //       this.pagination = JSON.parse(localStorage.getItem('pagination'));
    //       this.fetchSubpageData();
    //     }
    //     this.fetchSubpageData();
    //   } else {
    //     console.log("This NOT historical");
    //     this.fetchSubpageData();
    //   }
    // } else {
    //   this.fetchSubpageData();
    // }
  },
  watch:{
    $route (to, from){
      console.log("Is this from histoty?: ", to.meta.fromHistory);
      this.fetchData().then(data =>{
        this.data = data;
        console.log("This is a test")
      })
    
      // if (this.$route.meta.hasOwnProperty('fromHistory')) {
      //   if (this.$route.meta['fromHistory'] == true) {
      //     console.log("This is from the History")
      //     if (localStorage.getItem('pagination')) {
      //       // let tempUrl = localStorage.indexCall;
      //       this.pagination = JSON.parse(localStorage.getItem('pagination'));
      //       this.fetchSubpageData();
      //     }
      //     this.fetchSubpageData();
      //   } else {
      //     console.log("This NOT historical");
      //     this.fetchSubpageData();
      //   }
      // } else {
      //   this.fetchSubpageData();
      // }
    }
  },
  methods:{
    fetchData(){
       var id = this.$route.meta.id
       return axios.get('/api/v2/pages/'+id+'/').then(response => {
        //  console.log(JSON.stringify(response))
         return response.data;
       })
    },
    // fetchSubpageData(url=null) {
    //   let id = this.$route.meta.id
    //   let axObject = axios.create()
    //   axObject.interceptors.request.use(config => {
    //     this.loading_data = true;
    //     return config;
    //   })
    //   axObject.interceptors.response.use(response => {
    //     this.loading_data = false;
    //     return response;
    //   })
    //   let parsed = JSON.stringify(this.pagination)
    //   localStorage.setItem('pagination', parsed);
    //   let getUrl = '/api/v2/pages/?type=pages.BasicPage'+this.queryString.child_of+this.queryOffset+this.queryString.limit+this.queryString.fields+this.queryString.filter;
    //   // console.log("This is the url: " + url)
    //   if (url != null) {
    //     getUrl = url;
    //   }
    //   // localStorage.indexCall = getUrl;
    //   let vueObj = this
    //   return axObject.get(getUrl, { cancelToken: this.source.token }).then(response => {
    //     vueObj.subpages = response.data.items;
    //     vueObj.grouped_pages = response.data.items;
    //     vueObj.pagination.total = response.data.meta.total_count;
    //     return response.data;
    //   }).catch(function(thrown) {
    //     if (axios.isCancel(thrown)) {
    //       console.log('Request canceled', thrown.message);
    //     }
    //   })
    // },
    // nextPage() {
    //   if (this.pagination.current_page < this.page_count) {
    //     this.source.cancel();
    //     this.source = axios.CancelToken.source();
    //     this.subpages = [];
    //     this.grouped_pages = [];
    //     this.pagination.current_page = this.pagination.current_page+1;
    //     this.pagination.offset = this.pagination.limit*(this.pagination.current_page-1);
    //     this.queryString.offset = '&offset='+this.pagination.offset;
    //     this.fetchSubpageData();
    //   }
    // },
    // previousPage() {
    //   if (this.pagination.current_page > 1) {
    //     this.source.cancel();
    //     this.source = axios.CancelToken.source();
    //     this.subpages = [];
    //     this.grouped_pages = [];
    //     this.pagination.current_page = this.pagination.current_page-1;
    //     this.pagination.offset = this.pagination.limit*(this.pagination.current_page-1);
    //     this.queryString.offset = '&offset='+this.pagination.offset;
    //     this.fetchSubpageData();
    //   }
    // },
    filterAll() {
      // if (this.currentDateFilter){
      //   this.filterDate(this.currentDateFilter);
      // }
      // this.handleFilter(this.filter_array);
      this.pagiFilter = this.filter_array
    },
    handleFilter(filter_array){
      // let newFilterQuery = '';
      // for (let array in filter_array) {
      //   for (let filter in filter_array[array]) {
      //     newFilterQuery += '&node='+filter_array[array][filter];
      //   }
      // }
      // // console.log('This is the new filter query: ', newFilterQuery);
      // this.queryString.filter = newFilterQuery;
      // this.pagination.current_page = 1;
      // this.pagination.offset = 0;
      // this.queryString.offset = '&offset='+this.pagination.offset;
      // this.fetchSubpageData();
      let newFilterQuery = [];
      for (let array in filter_array) {
        for (let filter in filter_array[array].options) {
          if (filter_array[array].anded) {
            newFilterQuery.push({'type': 'node', 'value': filter_array[array].options[filter], 'orGroup': null});
          } else {
            newFilterQuery.push({'type': 'node', 'value': filter_array[array].options[filter], 'orGroup': Number(array)+1});
          }
        }
      }
      this.pagiFilter = newFilterQuery;
      // this.filter_array = filter_array;
      // if (this.currentDateFilter) {
      //   var temp_grouped_pages = this.dateFiltered;
      // } else {
      //   var temp_grouped_pages = this.subpages;
      // }
      // var empty_filters = [];
      // for (var filter in filter_array) {
      //   if (filter_array[filter].length > 0) {
      //   temp_grouped_pages = temp_grouped_pages.filter(page => {
      //     var intersection =  page.node_data.filter(x => filter_array[filter].includes(x.id));
      //     if (intersection.length > 0){
      //       return true;
      //     }
      //     return false;
      //     })
      //   } else {
      //     empty_filters.push('true');
      //   }
      // }
      // if (empty_filters.length == filter_array.length) {
      //   if (this.currentDateFilter){
      //     temp_grouped_pages = this.dateFiltered;
      //   } else {
      //     temp_grouped_pages = this.subpages;
      //   }
      // }

      // this.grouped_pages = temp_grouped_pages
    },
    filterDate(date_filter) {
      console.log("This is the dates passed")
      console.log(date_filter.startDateFilter);
      console.log(date_filter.endDateFilter);
      this.currentDateFilter = date_filter;
      let startFilter = Date.parse(date_filter.startDateFilter);
      let endFilter = Date.parse(date_filter.endDateFilter);
      console.log(startFilter);
      console.log(endFilter);
      // if startFilter & endFilter # if start_date or end_date falls between show
      // if startFilter # if start_date or end_date falls after
      // if endFilter # if start_date or end_date falls after
      let temp_pages = this.subpages;
      if (startFilter || endFilter){
        temp_pages = temp_pages.filter(page => {
          let page_end_date = Date.parse(page.end_date);
          let page_start_date = Date.parse(page.start_date);
          if (startFilter && endFilter) {
            if ((page_start_date >= startFilter || page_end_date >= startFilter) && (page_start_date <= endFilter || page_end_date <= endFilter)) {
              return true;
            }
          } else if (startFilter && !endFilter) {
            if (page_start_date >= startFilter || page_end_date >= startFilter) {
              return true;
            }
          } else if (!startFilter && endFilter) {
            if (page_start_date <= endFilter || page_end_date <= endFilter) {
              return true;
            }
          } else {
            return false;
          }
        })
      }
      this.dateFiltered = temp_pages;
    },
  }

}
</script>

<style scoped>
  .header-spacer {
    height: 90px;
  }

  .map-link{
    padding: 2rem 0 0 0;
    text-align: center;
    color: #fff;
    background: #1dd974;
    height: 7rem;
  }

  .map-link .column{
    /* display: flex; */
    /* justify-content: center; */
  }

  .map-link h4{
    display: inline-block;
    margin-left: 3rem;
  }

  .map-link-wrap{
    position: relative;
    display: inline-block;
    padding-left: 80px;
  }

  .map-link i{
       margin-top: -8px;
  }

  .map-link-circle {
    position: absolute;
    left: 0;
    top: -27px;
    z-index: 5;
    border-radius: 50%;
    background: #009e49;
    padding: 22px 17px;
    cursor: pointer;
    color: #fff;
    transition: all .25s;
  }

   .map-link-circle:hover{
     color: #c0f2d7;
   }

  .hero{
    position: relative;
    z-index: 2;
    background: #fff
  }

  .hero .row{
    min-height: 550px;
    flex-direction: row;
  }

  h1{
      /* text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%; */
  }

  p{
    margin-top: 0;
    font-weight: 500;
    font-size: 16px;
  }

  .has-background-quaternary{
    background: #0594dc;
  }
 
  .vert-center{
    width: 85%;
  }

  .column{
    position: relative;
  }

  .index-cta, .hero{
    min-height: 550px;
    background-size: cover;
  }

  .column img{
    display: block;
  }

  .subpage-top {
    /* border-top-left-radius: 1.5rem; */
    /* border-top-right-radius: 1.5rem; */
    border: 1rem;
    overflow: hidden;
    background: #333;
    /* padding: 2rem 2rem 1rem 2rem; */
  }

  .subpage-top img{
    /* border-top-left-radius: 1.5rem; */
    /* border-top-right-radius: 1.5rem; */
  }

  .subpage-item p{
    margin-bottom: .5rem;
  }

  .subpage-item h3{
    margin-top: .5rem;
  }

  .subpage-item{
    margin-bottom: 0;
    /* height: 420px;
    min-height: 420px; */
    /* background: #333; */
  }

  .subpage-inner{
    /* border: .35rem solid #333;
    border-radius: 1.5rem; */
    /* border-bottom-right-radius: 1.5rem; */
    padding: 2rem;
    /* height: 100%; */
    /* min-height: 260px; */
    /* color: #fff; */
    /* background: #333; */
  }

  #grouped-items{
    padding-top: 4rem;
    
  }

  #grouped-items .row{
    min-height: 50vh;
  }

  .index-cta{
    padding: 8rem 35% 8rem 4rem;
    padding: 8rem 4rem;
  }

  .heading-wrap{
    /* text-align: center; */
    margin-bottom: 1rem;
  }

  .heading-wrap h1{
    display: inline-block;
    /* border: 3px solid; */
    /* border-radius: 1rem; */
    margin-bottom: 0;
    padding: 1rem;
  }
  .index-image{
    background-size: cover;
    background-position: 50%
  }


  .cell-item {
    transition: transform 1s;
  }

  .cool-gradiant {
    background: linear-gradient(28deg, #E5E559, #E5E55C 50%, transparent 25%) transparent;
  }

  .hero .row{
    background-size: cover;
    background-position: 50%;
  }

  .cta-inner{
    /* border: 2px solid #fff; */
    border-radius: 9px;
    padding: 2rem;
    /* box-shadow: 0 16px 40px rgba(0,0,0,0.12) !important; */
  }
  
  .slide-enter-active, .slide-leave-active{
    transition: all .5s;
  }

  .slide-enter, .slide-leave-to{
    transform: translateX(-150%);
    opacity: .5;
  }

  .subpage-item{
    transition: all .5s;
    /* display: inline-block; */
  }

  .subpage-image{
    opacity: 0;
    transition: opacity .5s;
  }

  .subpage-image.loaded{
    opacity: 1;
  }

  /* .list-complete-item {
  transition: all 5s;
  display: inline-block;
  margin-right: 10px;
} */

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-bottom: 16px solid #3498db;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}



</style>